// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#lad-ask-question .el-main{margin:0}@media (min-width:768px){#lad-ask-question .el-main{margin:0 auto}}.dialog--ask-question .el-dialog__body{padding:40px}.dialog--ask-question .el-dialog__body .el-form{max-width:550px;margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
